import createIcon from '../../createIcon';

/**
 * @component @name HdrPlus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNSAxNC41SDguNVYxNS41SDEwLjVWMTQuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNiA3LjVIMTQuNVYxMC41SDE2VjcuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAyQzYuNDggMiAyIDYuNDggMiAxMkMyIDE3LjUyIDYuNDggMjIgMTIgMjJDMTcuNTIgMjIgMjIgMTcuNTIgMjIgMTJDMjIgNi40OCAxNy41MiAyIDEyIDJaTTEyIDE1LjVDMTIgMTYuMSAxMS42IDE2LjYgMTEuMSAxNi45TDEyIDE5SDEwLjVMOS42IDE3SDguNVYxOUg3VjEzSDEwLjVDMTEuMyAxMyAxMiAxMy43IDEyIDE0LjVWMTUuNVpNMTIgMTJIMTAuNVY5LjVIOC41VjEySDdWNkg4LjVWOEgxMC41VjZIMTJWMTJaTTE3LjUgMTZIMTZWMTcuNUgxNC41VjE2SDEzVjE0LjVIMTQuNVYxM0gxNlYxNC40OUgxNy41VjE2Wk0xNy41IDEwLjVDMTcuNSAxMS4zIDE2LjggMTIgMTYgMTJIMTNWNkgxNkMxNi44IDYgMTcuNSA2LjcgMTcuNSA3LjVWMTAuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HdrPlus = createIcon('HdrPlus', [
  ['path', { d: 'M10.5 14.5H8.5V15.5H10.5V14.5Z', key: 'kuu1gv' }],
  ['path', { d: 'M16 7.5H14.5V10.5H16V7.5Z', key: 'edp2zb' }],
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 15.5C12 16.1 11.6 16.6 11.1 16.9L12 19H10.5L9.6 17H8.5V19H7V13H10.5C11.3 13 12 13.7 12 14.5V15.5ZM12 12H10.5V9.5H8.5V12H7V6H8.5V8H10.5V6H12V12ZM17.5 16H16V17.5H14.5V16H13V14.5H14.5V13H16V14.49H17.5V16ZM17.5 10.5C17.5 11.3 16.8 12 16 12H13V6H16C16.8 6 17.5 6.7 17.5 7.5V10.5Z',
      key: 'a9ew7w',
    },
  ],
]);

export default HdrPlus;
